const ErrorIllustration = () => {
  return (
    <div className="relative w-full max-w-md mx-auto">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-100 to-teal-100 rounded-full opacity-60 animate-pulse"></div>

      <div className="relative z-10 p-8">
        <div className="flex items-center justify-center mb-4">
          <div className="relative">
            <div className="w-16 h-20 bg-gradient-to-b from-blue-600 to-blue-700 rounded-t-lg rounded-b-sm relative">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-8 h-8 bg-yellow-200 rounded-full"></div>
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 w-10 h-4 bg-yellow-400 rounded-t-lg"></div>
            </div>

            <div className="absolute -top-2 -right-8">
              <div className="w-1 h-16 bg-gray-600"></div>
              <div className="absolute top-0 left-1 w-8 h-5 bg-red-400 rounded-r-sm"></div>
            </div>
          </div>
        </div>

        <div className="flex justify-around items-end mt-8">
          <div className="w-12 h-8 bg-gray-400 rounded-lg transform rotate-12"></div>
          <div className="w-16 h-12 bg-gray-500 rounded-lg"></div>
          <div className="w-10 h-6 bg-gray-400 rounded-lg transform -rotate-12"></div>
        </div>

        <div className="flex justify-center mt-4">
          <div className="w-0 h-0 border-l-4 border-r-4 border-b-6 border-l-transparent border-r-transparent border-b-gray-800"></div>
        </div>

        <div className="absolute top-12 right-4 w-6 h-4 bg-gray-300 rounded-full opacity-70"></div>
        <div className="absolute bottom-8 left-6 w-4 h-3 bg-gray-300 rounded-full opacity-70"></div>
      </div>
    </div>
  );
};

export default ErrorIllustration;
